// Svelte-action долгого нажатия для iOS/десктопа.
//
// use:longpress={{ duration: 450, moveTolerance: 10 }} → CustomEvent 'longpress'.
// Отмена: движение пальца дальше tolerance (скролл ленты), pointerup раньше
// срока, pointercancel (iOS шлёт его при старте скролла/жеста системы).
// После срабатывания подавляется «призрачный» click, который iOS генерирует
// при отпускании пальца — иначе обработчик тапа откроется вторым.

export function longpress(node, options = {}) {
  const duration = options.duration ?? 450;
  const moveTolerance = options.moveTolerance ?? 10;

  let timer = null;
  let startX = 0;
  let startY = 0;
  let suppressClick = false;

  function clearTimer() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function onPointerDown(event) {
    if (event.pointerType === 'mouse' && event.button !== 0) {
      return;
    }
    startX = event.clientX;
    startY = event.clientY;
    suppressClick = false;
    clearTimer();
    timer = setTimeout(() => {
      timer = null;
      suppressClick = true;
      node.dispatchEvent(new CustomEvent('longpress'));
    }, duration);
  }

  function onPointerMove(event) {
    if (!timer) {
      return;
    }
    if (
      Math.abs(event.clientX - startX) > moveTolerance
      || Math.abs(event.clientY - startY) > moveTolerance
    ) {
      clearTimer();
    }
  }

  function onPointerEnd() {
    clearTimer();
  }

  function onClickCapture(event) {
    if (suppressClick) {
      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
    }
  }

  node.addEventListener('pointerdown', onPointerDown);
  node.addEventListener('pointermove', onPointerMove);
  node.addEventListener('pointerup', onPointerEnd);
  node.addEventListener('pointercancel', onPointerEnd);
  node.addEventListener('click', onClickCapture, true);

  return {
    update(nextOptions = {}) {
      options = nextOptions;
    },
    destroy() {
      clearTimer();
      node.removeEventListener('pointerdown', onPointerDown);
      node.removeEventListener('pointermove', onPointerMove);
      node.removeEventListener('pointerup', onPointerEnd);
      node.removeEventListener('pointercancel', onPointerEnd);
      node.removeEventListener('click', onClickCapture, true);
    },
  };
}
